let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("arhgZ"), load("4lmEc")]).then(() => parcelRequire('4z8RD'));